// extracted by mini-css-extract-plugin
module.exports = {"quill":"styles_quill__35mux"};